import React from 'react'

function Footer() {

    return (


        <footer className="bg-gray-100">
            <div
                className="relative mx-auto max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8 lg:pt-24"
            >
                <div className="absolute end-4 top-4 sm:end-6 sm:top-6 lg:end-8 lg:top-8">
                    <a
                        className="inline-block rounded-full bg-navy-blue p-2 text-white shadow transition hover:scale-105 sm:p-3 lg:p-4"
                        href="/#hero"
                    >
                        <span className="sr-only">Back to top</span>

                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fillRule="evenodd"
                                d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </a>
                </div>

                <div className="lg:flex lg:items-end lg:justify-between">
                    <div>
                        <div className="flex justify-center items-center text-night lg:justify-start">
                            <img src="/logo.png" className="w-10 h-10 mr-2" alt="Logo" />
                            <h1 className="font-title text-2xl font-bold">Maximum Contracting</h1>
                        </div>


                        <p
                            className="mx-auto mt-6 max-w-md text-center leading-relaxed text-gray-800 lg:text-left"
                        >
                            Concrete & Wet Basement Solutions
                        </p>
                    </div>

                    <ul
                        className="mt-12 flex flex-wrap justify-center gap-6 md:gap-8 lg:mt-0 lg:justify-end lg:gap-12"
                    >
                        <li>
                            <a className="text-gray-700 transition hover:text-gray-800/75" href="#about">
                                About
                            </a>
                        </li>

                        <li>
                            <a className="text-gray-700 transition hover:text-gray-800/75" href="#services">
                                Services
                            </a>
                        </li>

                        <li>
                            <a className="text-gray-700 transition hover:text-gray-800/75" href="#testimonials">
                                Testimonials
                            </a>
                        </li>

                        <li>
                            <a className="text-gray-700 transition hover:text-gray-800/75" href="#contact">
                                Contact Us
                            </a>
                        </li>
                    </ul>
                </div>

                <p className="mt-12 text-center text-sm text-gray-700 lg:text-right">
                    Copyright &copy; 2022. All rights reserved. Created by <a href='https://www.gavinabeele.com'>Gavin Abeele</a>
                </p>
            </div>
        </footer>


    );
}

export default Footer